import '../App.css';
import React, { useEffect } from "react";
import Nav from '../components/Nav.js';
import Footer from '../components/Footer.js';

// Motoway uygulamasının gizlilik politikası ve KVKK aydınlatma metni.
// Uygulamadaki metinle (motoway/src/features/legal/legal-text.ts) birlikte güncellenmelidir.
const MotowayPrivacy = () => {
  useEffect(() => {
    if (window.location.hash) {
      document.querySelector(window.location.hash)?.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <Nav minimal />
      <main className="privacy-page" lang="tr">
        <span className="eyebrow"><span className="dot" /> Motoway</span>

        <h1>Motoway Gizlilik Politikası</h1>
        <p><strong>Son güncelleme: 10 Ekim 2026</strong></p>
        <p>
          Bu metin, Motoway mobil uygulamasını kullanırken kişisel verilerinizin nasıl işlendiğini
          6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında açıklar.
        </p>

        <h2>1. Veri sorumlusu</h2>
        <p>
          Veri sorumlusu <strong>Meck Interactive</strong>’tir. Sorularınız ve başvurularınız için:{' '}
          <a href="mailto:app@meck-int.com">app@meck-int.com</a>
        </p>

        <h2>2. Hangi verileri işliyoruz?</h2>
        <ul>
          <li><strong>Hesap:</strong> ad soyad, e-posta adresi, cep telefonu numarası, doğum tarihi, şehir, motorlarınız ve isteğe bağlı plakaları, profil fotoğrafı. Telefon numaranız ve doğum tarihiniz diğer üyelere gösterilmez; plakanızı yalnızca arkadaşlarınız görür.</li>
          <li><strong>Konum:</strong> rota hesaplarken ve haritada konumunuzu gösterirken anlık konumunuz; sürüş kaydı açıkken arka planda konum, hız ve yükseklik.</li>
          <li><strong>Paylaştıklarınız:</strong> gönderiler, fotoğraflar, yorumlar, beğeniler, rotalar, puanlar, eklediğiniz mekânlar ve yol bildirimleri.</li>
          <li><strong>Topluluk:</strong> arkadaşlıklar, grup üyelikleri, etkinlik katılımları, engelleme ve şikâyet kayıtları.</li>
          <li><strong>Mesajlar:</strong> arkadaşlarınıza ve gruplarınıza yazdığınız mesajlar. Yalnızca yazışmanın tarafları ya da grubun üyeleri okuyabilir; şikâyet edilen mesajlar moderatörlerce incelenebilir.</li>
          <li><strong>Cihaz:</strong> anlık bildirim gönderebilmek için cihazınızın bildirim adresi (push token) ve platformu.</li>
          <li><strong>Yalnızca telefonunuzda kalanlar:</strong> garaj, bakım ve yakıt kayıtları, acil durum kişisi, paylaşmadığınız sürüş kayıtları, indirdiğiniz çevrimdışı haritalar. Bunlar sunucuya gönderilmez.</li>
        </ul>
        <p>Uygulama reklam göstermez, sizi uygulamalar ve web siteleri arasında izlemez ve verilerinizi satmaz.</p>

        <h2>3. Neden işliyoruz?</h2>
        <ul>
          <li>Üyelik oluşturmak ve hesabınızı korumak.</li>
          <li>16 yaş sınırını uygulamak.</li>
          <li>Motosiklete göre rota, süre, trafik, hava ve yol durumu sunmak.</li>
          <li>Sürüşlerinizi kaydetmek ve isteğinizle rota olarak paylaşmak.</li>
          <li>Akış, grup, etkinlik, mesajlaşma ve canlı grup sürüşü özelliklerini çalıştırmak.</li>
          <li>Yol bildirimlerini diğer sürücülere göstermek.</li>
          <li>Şiddet ve cinsellik içeren paylaşımları engellemek, kötüye kullanımı önlemek ve şikâyetleri değerlendirmek.</li>
        </ul>

        <h2>4. Hukuki sebep</h2>
        <p>
          Hesap, topluluk ve mesaj verileri sözleşmenin kurulması ve ifası (KVKK m. 5/2-c) için;
          paylaşımların denetlenmesi ve kötüye kullanımın önlenmesi meşru menfaat (KVKK m. 5/2-f)
          için işlenir. Konum verisi açık rızanızla işlenir; rızanızı telefonunuzun konum
          izinlerinden ya da hesabınızı silerek her zaman geri alabilirsiniz.
        </p>

        <h2>5. İçerik denetimi</h2>
        <p>
          Paylaşmak istediğiniz yazı ve fotoğraflar, yayınlanmadan önce otomatik olarak şiddet ve
          cinsellik açısından denetlenir. Bu denetim için içerik OpenAI’nin denetim hizmetine
          gönderilir. Uygun bulunmayan içerik paylaşılmaz ve fotoğraf silinir. Denetim sonucunda
          hesabınız hakkında otomatik bir karar verilmez; hesap askıya alma kararlarını
          moderatörler şikâyetleri inceleyerek verir.
        </p>

        <h2>6. Kimlerle paylaşıyoruz?</h2>
        <p>Hizmeti sunabilmek için aşağıdaki sağlayıcılara yalnızca gerekli veri gönderilir:</p>
        <ul>
          <li><strong>Supabase</strong> (veritabanı, giriş, dosya depolama): hesap ve paylaşım verileriniz.</li>
          <li><strong>OpenAI</strong> (içerik denetimi, ABD): paylaşmak istediğiniz yazı ve fotoğraflar.</li>
          <li><strong>Expo</strong> (anlık bildirim, ABD): bildirim adresiniz ve bildirim metni.</li>
          <li><strong>Apple ve Google</strong>: bu hesaplarla giriş yaparsanız kimlik doğrulama bilgileri.</li>
          <li><strong>TomTom</strong> (rota ve trafik): başlangıç ve varış koordinatları.</li>
          <li><strong>Open-Meteo</strong> (hava durumu): rota üzerindeki noktaların koordinatları.</li>
          <li><strong>Photon / Komoot</strong> (yer arama): arama metni ve yaklaşık konum.</li>
          <li><strong>OpenFreeMap ve OpenStreetMap</strong> (harita ve mekân verisi): görüntülenen bölge.</li>
        </ul>
        <p>
          Bu sağlayıcıların sunucuları yurt dışında bulunduğundan verileriniz yurt dışına aktarılır.
          Kanun gereği yetkili kurumlardan gelen talepler dışında verileriniz başka kimseyle
          paylaşılmaz.
        </p>

        <h2>7. Görünürlük</h2>
        <p>
          Hesabınızı Profil &gt; Hesabım &gt; Hesap gizliliği altından açık ya da özel
          yapabilirsiniz. Özel hesap aramalarda çıkmaz; gönderilerini ve rotalarını yalnızca
          arkadaşları görür. “Arkadaşlar” ya da “Herkese açık” seçtiğiniz rotalar, gönderiler,
          eklediğiniz mekânlar ve yol bildirimleri diğer üyelerce görülür. Canlı grup sürüşünde
          konumunuz yalnızca o ekran açıkken aynı gruptaki üyelere gösterilir ve sunucuda saklanmaz.
        </p>

        <h2>8. Ne kadar saklıyoruz?</h2>
        <p>
          Verileriniz hesabınız açık olduğu sürece saklanır. Yol bildirimleri türüne göre 2 saat
          ile 7 gün arasında kendiliğinden kaldırılır. Sildiğiniz mesajlar karşı taraftan da
          silinir. Şikâyet kayıtları, incelemenin gerektirdiği süre boyunca tutulur.
        </p>

        <h2 id="hesap-silme">9. Hesabınızı silme</h2>
        <p>
          Hesabınızı uygulama içinden <strong>Profil &gt; Hesabım &gt; Hesabımı sil</strong> yoluyla
          silebilirsiniz. Silme işlemi profilinizi, gönderilerinizi, fotoğraflarınızı, rotalarınızı,
          mesajlarınızı ve diğer kayıtlarınızı kalıcı olarak kaldırır. Uygulamaya erişemiyorsanız
          hesabınıza kayıtlı e-posta adresinden{' '}
          <a href="mailto:app@meck-int.com?subject=Motoway%20hesap%20silme">app@meck-int.com</a>{' '}
          adresine “Motoway hesap silme” konulu bir e-posta gönderin; hesabınız 30 gün içinde
          silinir.
        </p>

        <h2>10. Çocuklar</h2>
        <p>Motoway 16 yaşından küçüklere yönelik değildir ve 16 yaşından küçüklerin üye olmasına izin vermez.</p>

        <h2>11. Haklarınız</h2>
        <p>
          KVKK’nın 11. maddesi uyarınca verilerinizin işlenip işlenmediğini öğrenme, bilgi isteme,
          düzeltilmesini ya da silinmesini isteme, aktarıldığı kişileri öğrenme, otomatik
          sistemlerle analiz sonucu aleyhinize bir sonuca itiraz etme ve zararın giderilmesini
          talep etme haklarına sahipsiniz. Başvurularınızı{' '}
          <a href="mailto:app@meck-int.com">app@meck-int.com</a> adresine iletebilirsiniz.
        </p>

        <h2>12. Değişiklikler</h2>
        <p>
          Bu politikayı güncellediğimizde bu sayfadaki “Son güncelleme” tarihi değişir.
        </p>
      </main>
      <Footer />
    </>
  );
};

export default MotowayPrivacy;
